module.exports = __webpack_public_path__ + "static/media/llanta-medicion-yellow.31b14ed7.svg";